import { Validator } from "fluentvalidation-ts";
import { matchIsValidTel } from "mui-tel-input";

type User = {
  name: string;
  firstName: string;
  lastName: string;
  userName: string;
  password: string;

  cellNumber: string;
  email: string;
  
  phoneNumber: string;


};

class UserValidator extends Validator<User> {
  constructor() {
    super();

    this.ruleFor("name") // This is type-safe! (Argument is of type 'name' | 'age')
      .notNull()
      .notEmpty()
      .withMessage("Perfavore inserisci il tuo name");

    

    this.ruleFor("cellNumber") // This is type-safe! (Argument is of type 'name' | 'age')
      .notNull()
      .notEmpty()
      .withMessage("Perfavore inserisci un numero di telefono")
      .must((phone) => matchIsValidTel(phone))
      .withMessage("Numero non valido");

    this.ruleFor("email")
      .notNull()
      .notEmpty()
      .withMessage("Perfavore inserisci la tua e-mail")
      .emailAddress()
      .withMessage("E-mail non valida");

    this.ruleFor("phoneNumber")
      .notNull()
      .notEmpty()
      .withMessage("Perfavore inserisci un numero di cellulare")
      .must((phone) => matchIsValidTel(phone))
      .withMessage("Numero non valido");

      this.ruleFor("password")
      .notEmpty()
      .notNull()
      .withMessage("Perfavore inserisci la password")
      .matches(new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'))
       .withMessage("Password requirements: 8-20 characters, 1 number, 1 letter, 1 symbol.");

  }

}

export default UserValidator;
